import { ReactNode } from 'react';
import { DraggableCard } from './DraggableCard';

export interface DraggableColumnCardProps {
  colId: string;
  index: number;
  headerName: string;
  hide: boolean;
  setColumnVisible: (key: string, visible: boolean) => void;
  disabled?: boolean;
  variant?: 'toggle' | 'remove';
  badge?: ReactNode;
  cardClassName?: string;
  enableCardShadow?: boolean;
  useDefaultCardStyles?: boolean;
}

export function DraggableColumnCard({
  colId,
  index,
  headerName,
  hide,
  setColumnVisible,
  variant = 'toggle',
  badge,
  cardClassName,
  enableCardShadow,
  useDefaultCardStyles
}: DraggableColumnCardProps) {
  return (
    <DraggableCard
      draggableId={colId}
      index={index}
      label={headerName}
      checked={!hide}
      onChange={() => setColumnVisible(colId, hide)}
      badge={badge}
      cardClassName={cardClassName}
      enableCardShadow={enableCardShadow}
      useDefaultCardStyles={useDefaultCardStyles}
      actionElement={
        variant === 'remove' ? (
          <button
            type="button"
            aria-label={`Remove ${headerName} column`}
            data-testid={`${colId}-remove-button`}
            className="ml-auto pl-3 text-gray-400 hover:text-gray-600"
            onClick={() => setColumnVisible(colId, false)}>
            ✕
          </button>
        ) : undefined
      }
    />
  );
}
